/**
 * invite-qr.ts — desktop QR code for the invite link (ENG-417, spec 5.4/8.1).
 *
 * Renders the current invite URL as an inline SVG QR code so a visitor on a
 * desktop browser can scan it with their phone camera and land on the SAME
 * lander page there — where the platform's Universal Link / App Link
 * association takes over if the app is installed, or the store hand-off runs
 * if not. Generated entirely client-side with no network call: `qrcode-generator`
 * (MIT, Kazuhiko Arase) is a small, dependency-free QR encoder, so this keeps
 * the page's "no network call, ever" shape (spec 5.4) — there is no server-
 * rendered QR image endpoint to fetch from, and none is needed.
 */
import qrcodeFactory from "qrcode-generator";

/** Module pixels per QR module. `null` type-number auto-selects the smallest
 *  version that fits the URL at this error-correction level. */
const CELL_SIZE = 4;
const MARGIN = 2;
/** 'M' (15% recovery) tolerates an imperfect phone-camera scan without
 *  inflating an already-long invite URL into a denser code than 'Q'/'H' would. */
const ERROR_CORRECTION_LEVEL = "M";

/** Render `url` as an inline `<svg>...</svg>` string. */
export function inviteQrSvg(url: string): string {
  const qr = qrcodeFactory(0, ERROR_CORRECTION_LEVEL);
  qr.addData(url);
  qr.make();
  return qr.createSvgTag({ cellSize: CELL_SIZE, margin: MARGIN });
}
